<template>
  <div class="container justify-content-center" px-1>
    <div class="sticky1">
      <h1 class="text-center">ЦЕНЫ НА ЯГОДУ</h1>

      <div class="mb-1 mt-1 row">
        <div class="col-sm-9 label-class">
          <v-select :options="users" label="label" v-model="currentReceiver">
            <template #option="user">
              <span>{{ user.receiver.fullname }}: {{ user.receiver.address }}</span>
            </template>
            <template #selected-option="user">
              <span>{{ user.receiver.fullname }}</span>
            </template>
          </v-select>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div
        v-for="(user, indexUser) in pricesFilter"
        :key="indexUser"
        class="container pb-2 pt-1 px-0"
      >
        <div class="card lh-1">
          <div class="card-body">
            <div class="row row-cols-1">
              <div class="col">
                <span class="fs-5">{{ user.receiver.receiver.fullname }}</span>
              </div>
            </div>

            <div v-if="isAdmin"  class="row row-cols-2 mt-2">
              <div class="col">
                <Multiselect
                  v-model="user.selectedBerry"
                  :options="berries"
                  :loading="false"
                  :internal-search="false"
                  valueProp="_id"
                  trackBy="label"
                  label="label"
                  :filterResults="true"
                  :minChars="2"
                  :resolveOnLoad="true"
                  :searchable="true"
                  class="deliverer1"
                  style="min-height: 3rem"
                  noOptionsText="Не найден"
                  placeholder="Ягода"
                  required
                >
                </Multiselect>
              </div>
              <div class="col">
                <button class="btn btn-light" @click="showBerry(user)">Добавить</button>
                <button class="btn btn-light" @click="clearPrices(user)">Очистить цены</button>
              </div>
            </div>

            <div class="row row-cols pb-1 pt-1">
              <div class="col-3 text-muted px-0"></div>
              <div v-if="isWholesaler || isAdmin" class="col text-muted px-0 pe-1 price-head">
                Базовая
              </div>
              <div v-if="isWholesaler || isAdmin" class="col text-muted px-0 pe-1 price-head">
                Дельта
              </div>
              <div class="col text-muted px-0 pe-1 price-head">Текущая</div>
              <div class="col text-muted px-0 pe-1 price-head">Минус общ</div>
              <div v-if="isWholesaler || isAdmin" class="col text-muted px-0"></div>
            </div>
            <form
              v-for="(price, indexPrice) in userPricesFilter(user.prices)"
              :key="indexPrice"
              @submit="savePrice(price, $event)"
            >
              <div class="row row-cols pt-1">
                <div class="col-3 ps-0 pe-1">
                  {{ store.getters.getBerry(price.berry).label }}
                </div>

                <div v-if="isWholesaler || isAdmin" class="col ps-0 pe-1">
                  <input
                    class="form-control p-1 fs-5"
                    v-model="price.base"
                    type="number"
                    required
                    :disabled="!isAdmin"
                  />
                </div>
                <div v-if="isWholesaler || isAdmin" class="col ps-0 pe-1">
                  <input
                    class="form-control p-1 fs-5"
                    v-model="price.delta"
                    type="number"
                    :disabled="!isAdmin"
                  />
                </div>
                <div class="col ps-0 pe-1">
                  <input
                    class="form-control p-1 fs-5"
                    v-model="price.current"
                    type="number"
                    :disabled="!(isWholesaler || isAdmin)"
                  />
                </div>
                <div class="col ps-0 pe-1">
                  <input
                    class="form-control p-1 fs-5"
                    v-model="price.hostelMinus"
                    type="number"
                    :disabled="!isAdmin"
                  />
                </div>
                <div v-if="isWholesaler || isAdmin" class="col ps-0 pe-1 btn-group">
                  <button
                    type="submit"
                    class="btn btn-light"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Сохранить цену"
                  >
                    <font-awesome-icon icon="save" />
                    <div v-if="price.loadingSave" class="spinner-border" role="status">
                      <span class="sr-only"></span>
                    </div>
                  </button>
                </div>
              </div>

              <div class="row row-cols-1 pt-0"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
//import * as bootstrap from 'bootstrap'
//import { Modal } from 'bootstrap'
// import useCardsMixin from "@/components/cardsMixin.js";
import useCommonMixin from "@/components/commonMixin.js";
import "vue-select/dist/vue-select.css";
import Multiselect from "@vueform/multiselect";

export default {
  name: "Prices",
  components: { Multiselect },

  setup(props) {
    useCommonMixin();
    const { isAdmin, isWholesaler, asyncForEach } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const warningBus = inject("warningBus"); // Inject `emitter`
    const currentBerry = ref();
    const berries = computed(() => store.getters.berry);
    const users = ref([]);
    const roles = ref([]);
    const currentReceiver = ref();
    const prices = ref([]);
    const priceCommon = ref([]);

    
    const savePrice = async (price, event) => {
      if (event) {
        event.preventDefault();
      }
      price.loadingSave = true;
      let response = await store.dispatch("POSTprice", price);
      if (response.status) {
        price._id = response.data._id;
        price.base = response.data.base;
        price.current = response.data.current;
        price.delta = response.data.delta;
        price.hostelMinus = response.data.hostelMinus;
        price.receiver = response.data.receiver;
      } else {
        warningBus.emit("show", [`Ошибка записи цены`, response.data]);
      }
      price.loadingSave = false;
    };

    const addPrice = (berry, receiver) => {
      let newPrice = {
        berry: berry,
        base: 0,
        current: 0,
        delta: 0,
        hostelMinus: 0,
        receiver: receiver
      };
      let priceIndex = prices.value.push(newPrice) - 1;
      return priceIndex;
    };

    const removePrice = async (price, priceIndex) => {
      const confirmFunc = async () => {
        if (price._id) {
          let response = await store.dispatch("REMOVEprice", price._id);
          if (response.status) {
            prices.value.splice(priceIndex, 1);
          } else {
            warningBus.emit("show", ["Ошибка. Повторите позже.", response.data]);
          }
        } else {
          prices.value.splice(priceIndex, 1);
        }
      };
      warningBus.emit("confirm", {
        func: confirmFunc,
        msgs: ["Вы действительно хотите удалить цены?", price.receiver.receiver.fullname]
      });
    };

    const init = async () => {
      let responsePrices = await store.dispatch("FETCHprices");
      prices.value = responsePrices.status ? responsePrices.data : [];

      let responseUsers = await store.dispatch("FETCHuser", "receiver");
      users.value = responseUsers.status ? responseUsers.data : [];
      users.value.forEach(user => {
        user.label = `${user.receiver.fullname} ${user.receiver.address}`;
        user.receiver.fullname = `${user.receiver.fullname} (${user.receiver.masterFullname})`;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];
      await store.dispatch("FETCHberry");

      priceCommon.value = [];
      users.value.forEach(user => {
        let berriesPrice = [];
        berries.value.forEach(berry => {
          let priceIndex = prices.value.findIndex(price => {
            return price.berry == berry._id && price.receiver && price.receiver._id == user._id;
          });
          let newPrice = {};
          if (priceIndex >= 0) {
            newPrice = prices.value[priceIndex];
          } else {
            //user.receiver.fullname = price.receiver.receiver.fullname
            let newPriceIndex = addPrice(berry._id, user);
            newPrice = prices.value[newPriceIndex];
          }
          berriesPrice.push(newPrice);
        });

        priceCommon.value.push({
          receiver: user,
          prices: berriesPrice
        });
      });

      priceCommon.value.sort((a, b) => {
        if (a.receiver.label < b.receiver.label) return -1;
        if (a.receiver.label > b.receiver.label) return 1;
        return 0;
      });
    };

    const pricesFilter = computed(() => {
      let result = priceCommon.value;
      if (currentReceiver.value && "_id" in currentReceiver.value) {
        console.log("filter");

        result = result.filter(
          item =>
            item.receiver.receiver.master == currentReceiver.value._id ||
            item.receiver._id == currentReceiver.value._id
        );
      }
      return result;
    });

    const userPricesFilter = computed(() => {
      return userPrices => {
        let result = userPrices;
        result = result.filter(priceRow => {
          let showPrice = false;
          if ("show" in priceRow && priceRow.show) showPrice = true;
          if (
            priceRow.base > 0 ||
            priceRow.current > 0 ||
            priceRow.delta > 0 ||
            priceRow.hostelMinus > 0
          )
            showPrice = true;
          return showPrice;
        });
        return result;
      };
    });

    const showBerry = (userPrices) => {
      if ('selectedBerry' in userPrices) {
        let berryIndex = userPrices.prices.findIndex(priceItem => priceItem.berry == userPrices.selectedBerry)
        if (berryIndex >= 0) {
          userPrices.prices[berryIndex].show = true
        }
      }
    }

    const clearPrices = async(userPrices) => {
      let confirm = window.confirm(
        `Вы действительно хотите очистить все цены ${userPrices.receiver.receiver.fullname}?`
      );
      if (!confirm) {
        return;
      }

      await asyncForEach(userPrices.prices, async (userPrice) => {
        userPrice.base = 0
        userPrice.current = 0
        userPrice.delta = 0
        userPrice.hostelMinus = 0
        await savePrice(userPrice, null)
      })

    }

    const receiverLabel = user => {
      return `${user.receiver.fullname}`;
    };

    onMounted(init);

    return {
      prices,
      savePrice,
      removePrice,
      addPrice,
      berries,
      currentBerry,
      pricesFilter,
      users,
      currentReceiver,
      receiverLabel,
      isAdmin,
      priceCommon,
      store,
      isWholesaler,
      userPricesFilter,
      showBerry,
      clearPrices,
    };
  }
};
</script>

<style>
.price-head {
  /* transform: rotate(-45deg); */
  font-size: 0.8rem;
}
</style>
